import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { getSubscriptionPath } from '../../../../../routes/constants';
import messages from '../../messages';
import styles from '../carriers-additional.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode[]} props.chunk
 * @param {boolean} props.disabled
 * @param {() => void} props.onLinkClicked
 * @returns {React.JSX.Element}
 */
export const SubscriptionLink = ({ chunk, disabled, onLinkClicked }) => {
  if (disabled) {
    return (
      <Tooltip>
        <span className={styles['disabled-text']}>{chunk}</span>
        <TooltipContent>
          <FormattedMessage {...messages.contactAdmin} />
        </TooltipContent>
      </Tooltip>
    );
  }
  return (
    <Link onClick={onLinkClicked} to={getSubscriptionPath()}>
      {chunk}
    </Link>
  );
};
